import { formatPattern } from './api/formatPattern';
import { api } from './api/api';
import { METHOD, REQUEST_URL, KEYCLOAK_STORAGE_KEY } from './api/constants';
import { strings } from '../localization';
import moment from 'moment';

const ROUTE_PREFIX = '';

// Params
const HOME_ID_ROUTE_PARAM = 'homeId';
const INVITATION_HASH_ID_ROUTE_PARAM = 'invitationHashId';

const ROUTE_NAMES = {
    LOGIN: `${ROUTE_PREFIX}/login`,
    INVITATION: `${ROUTE_PREFIX}/invitation/:${INVITATION_HASH_ID_ROUTE_PARAM}`,
    INVITATION_OWNER: `${ROUTE_PREFIX}/invitation-owner/:${INVITATION_HASH_ID_ROUTE_PARAM}`,
    REGISTRATION: `${ROUTE_PREFIX}/register`,
    DASHBOARD: `${ROUTE_PREFIX}/dashboard`,
    HOMES: `${ROUTE_PREFIX}/homes`,
    HOME_DETAIL: `${ROUTE_PREFIX}/home/:${HOME_ID_ROUTE_PARAM}`,
    DEVICES: `${ROUTE_PREFIX}/devices`,
    ADMINISTRATION: `${ROUTE_PREFIX}/administration`,
    TESTS: `${ROUTE_PREFIX}/tests`,
    TRAIN: `${ROUTE_PREFIX}/training`,
    REPORTS: `${ROUTE_PREFIX}/reports`,
    DEVICE_ID: `${ROUTE_PREFIX}/device/:id`,
    DEVICE_ID_CONSOLE: `${ROUTE_PREFIX}/device/:id/console`,
    MOBILE: `${ROUTE_PREFIX}/mobile`
};

const AFTER_LOGOUT_REDIRECT = `${window.location.origin}${ROUTE_NAMES.DASHBOARD}`;

const SETTINGS_PROPERTY_TYPES = {
    PAIR_MODE_TIMEOUT: 'PAIR_MODE_TIMEOUT',
    PAGINATION: 'PAGINATION',
    PORTAL_LINK: 'PORTAL_LINK',
    PORTAL_USERNAME: 'PORTAL_USERNAME',
    PORTAL_PASSWORD: 'PORTAL_PASSWORD'
};

export const getTime24h = time => {
    if(!time) return null;
    const m = moment(time, 'hh:mm:ss a');
    return m.format('HH:mm');
};

const generateTimeString = (date, addSecs = true) => {
    const h = `0${date.getHours()}`;
    const m = `0${date.getMinutes()}`;
    const s = `0${date.getSeconds()}`;
    return `${h.substr(-2)}:${m.substr(-2)}${addSecs ? `:${s.substr(-2)}` : ``}`;
};

const convertToLocalDate = (date, lang) => {

    if (!date || typeof date === 'string') return date;

    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };

    switch(lang){
        case 'de':
            return date.toLocaleDateString('de-DE', options);
        case 'sk':
            return date.toLocaleDateString('sk-SK', options);
        default:
            return date.toLocaleDateString('en-US', options);
    }
};

const getDisplayLabelForMeterType = (meterType) => {
    if(meterType.toString() in strings.dashboard)
    {
        return strings.dashboard[meterType.toString()]
    }
    return meterType;
};

const periods = {
    today: 'TD',
    yesterday: 'YD',
    thisWeek: 'TW',
    lastWeek: 'LW',
    thisMonth: 'TM',
    lastMonth: 'LM',
    thisQuarter: 'TQ',
    lastQuarter: 'LQ',
    thisYear: 'TY',
    lastYear: 'LY'
}

const generateDateTimeString = (date, addSecs = true, lang = 'en') => `${convertToLocalDate(date, lang)} ${generateTimeString(date, addSecs)}`;

const getOnlySubmetersIfExists = (deviceData) => {
    const submetersAvailable = deviceData && deviceData.find(item => (item.deviceId < 0));
    return submetersAvailable
        ? deviceData.filter(item => item.meterId > -1)
        : deviceData
}

export {
    api,
    formatPattern,
    generateDateTimeString,
    generateTimeString,
    convertToLocalDate,
    getDisplayLabelForMeterType,
    getOnlySubmetersIfExists,
    periods,
    METHOD,
    ROUTE_NAMES,
    HOME_ID_ROUTE_PARAM,
    INVITATION_HASH_ID_ROUTE_PARAM,
    REQUEST_URL,
    AFTER_LOGOUT_REDIRECT,
    KEYCLOAK_STORAGE_KEY,
    SETTINGS_PROPERTY_TYPES
};
